module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/127PzhY/images/frontcover.jpg?1718044755450",
      "alt": "This image is the cover for the book Victoria's Generals"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Victoria's Generals\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("The senior British generals of the Victorian era - men like Wolseley, Roberts, Gordon and Kitchener - were heroes of their time. As soldiers, administrators and battlefield commanders they represented the empire at the height of its power. But they were a disparate, sometimes fractious group of men. They exhibited many of the failings as well as the strengths of the British army of the late nineteenth-century. And now, when the Victorian period is being looked at more critically than before, the moment is right to reassess them as individuals and as soldiers. This balanced and perceptive study of these eminent military men gives a fascinating insight into their careers, into the British army of their day and into a now-remote period when Britain was a world power.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Steven J. Corvi, Ian F. W. Beckett\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Ian F. W. Beckett & Steven J. Corvi are both authors and military historians.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Pen and Sword\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0